import React from 'react';
import { array, number, string } from 'prop-types';

import useStyles from 'hooks/useStyles';
import useGetCurrentImageType from 'hooks/useGetCurrentImageType';
import CourseIntroCard from 'routes/course/components/CourseIntroCard';
import { COURSE_LIST_CLICK } from 'constants/gtmEvent';

import styles from './CourseList.scss';

function CourseList({ groupId, groupTitle, courseList }) {
  useStyles(styles);

  const { imageType, setContainerRef } = useGetCurrentImageType();

  return (
    <div ref={setContainerRef} className={styles.courseList}>
      {courseList.map(({ picture, ...courseInfo }, index) => {
        return (
          <CourseIntroCard
            {...courseInfo}
            // eslint-disable-next-line react/no-array-index-key
            key={`${groupId}-${courseInfo.id}-${index}`}
            hasFreeLesson={false}
            eventName={COURSE_LIST_CLICK}
            eventData={{
              courseGroupId: groupId,
              courseGroupName: groupTitle,
              itemIndex: index,
            }}
            pictureUrl={picture[imageType]}
          />
        );
      })}
    </div>
  );
}

CourseList.defaultProps = {
  courseList: [],
};

CourseList.propTypes = {
  groupId: number.isRequired,
  groupTitle: string.isRequired,
  courseList: array,
};

export default CourseList;
